import React from "react";
import { useParams } from "react-router-dom";
//
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
//
import Table from "components/enhancedTable";
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
//import ButtonGroup from '@material-ui/core/ButtonGroup';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Grid from '@material-ui/core/Grid';

import { green, blue, lightGreen, lightBlue, grey } from '@material-ui/core/colors';
import CloudIcon from '@material-ui/icons/Cloud';
import CloudDoneIcon from '@material-ui/icons/CloudDone';
import CircularProgress from "@material-ui/core/CircularProgress";
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import PictureAsPdfOutlinedIcon from '@material-ui/icons/PictureAsPdfOutlined';
import FileCopyIcon from '@material-ui/icons/FileCopy';

import CancelCooperativeContractDialog from "containers/cancelCooperativeContractDialog";
import ExportCooperativeContractDialog from "containers/exportCooperativeContractDialog";
import DispatchCooperativeContractDialog from "containers/dispatchCooperativeContractDialog";

const GET_COOPERATIVE_NAME = gql`
  query GetCooperative($id: ID!) {
    cooperative(id: $id) {
      businessName
    }
  }
`;

const GET_ALL_COOPERATIVE_CONTRACTS = gql`
  query GetAllContractBundles($cooperative: String!) {
    contractBundles(cooperative: $cooperative) {
      id
      title
      status      
      docFolder {
        url
      }
      pdfFolder {
        url
      }  
      createdAt    
    }
  }
`;

const etl = data => {  
  return data.contractBundles.map(
    (contract, index) => [
      contract.title,
      <Grid container
        direction="row"
        justify="flex-start"
        alignItems="center"
        spacing={0}>
        <Grid item xs>
          <RenderStatus status={contract.status} />
        </Grid>
      </Grid>,      
      new Date(contract.createdAt).toLocaleDateString(),
      /*<ButtonGroup variant="text" size="small" aria-label="small contained button group">
        {contract.docFolder && <Button><Link href={contract.docFolder.url} rel="noopener noreferrer" target="_blank">Cartella documenti</Link></Button>}
        {contract.pdfFolder && <Button><Link href={contract.pdfFolder.url} rel="noopener noreferrer" target="_blank">Cartella pdf</Link></Button>}
        
        {contract.docFolder && !contract.pdfFolder && <ExportCooperativeContractDialog contract={contract}/>}
        {contract.docFolder && <CancelCooperativeContractDialog contract={contract}/>}
      </ButtonGroup>*/
      <Grid container
        direction="row"
        justify="flex-start"
        alignItems="center"
        spacing={0}>
        <Grid item xs>
          {true && contract.docFolder &&
            <Tooltip title={'Cartella documenti'} placement="top">
              <Link href={contract.docFolder.url} rel="noopener noreferrer" target="_blank">
                <IconButton
                  size="small"
                  //color="primary"      
                  aria-label="add">
                  <FileCopyIcon />
                </IconButton>
              </Link>
            </Tooltip>}
        </Grid>
        <Grid item xs>
          {contract.pdfFolder &&
            <Tooltip title={'Cartella pdf'} placement="top">
              <Link href={contract.pdfFolder.url} rel="noopener noreferrer" target="_blank">
                <IconButton
                  size="small"
                  //color="primary"      
                  aria-label="add">
                  <PictureAsPdfIcon />
                </IconButton>
              </Link>
            </Tooltip>}
        </Grid>           
      </Grid>,
      <Grid container
      direction="row"
      justify="flex-start"
      alignItems="center"
      spacing={0}>
        <Grid item xs>
          {contract.docFolder && !contract.pdfFolder 
            && <ExportCooperativeContractDialog contract={contract}/>}
        </Grid>
        <Grid item xs>
          {contract.docFolder && contract.pdfFolder 
            && <DispatchCooperativeContractDialog contract={contract}/>}
        </Grid>        
        <Grid item xs>               
          {contract.docFolder 
            && <CancelCooperativeContractDialog contract={contract}/>}
        </Grid>
    </Grid>       
    ]
  );
};

export default function () {
  const { id } = useParams();

  const {
    data: cooperativeNameData,
    loading: cooperativeNameLoading,
    error: cooperativeNameError
  } = useQuery(GET_COOPERATIVE_NAME, {
    variables: { id }
  });

  const { data, loading, error } = useQuery(GET_ALL_COOPERATIVE_CONTRACTS, {
    variables: {
      cooperative:
        cooperativeNameData && cooperativeNameData.cooperative.businessName
    },
    pollInterval: process.env.REACT_APP_GRAPHQL_API_POLL_INTERVAL
  });

  if (loading || cooperativeNameLoading) return <p>Caricamento...</p>;
  if (!data && (error || cooperativeNameError)) return <p>ERROR: {error.message}</p>;

  return <Table headers={["Titolo", "Stato", "Creato il", "Documenti", "Azioni"]} rows={etl(data)} sort="desc" sortBy="Creato il" />;
}

const RenderStatus = ({ status }) => {
  if (status === 'PREPARED') return (<Tooltip title={status} placement="top"><CheckCircleOutlineIcon style={{ color: grey[500] }} /></Tooltip>)
  if (status === 'EXPORTED') return (<Tooltip title={status} placement="top"><CheckCircleIcon style={{ color: grey[500] }} /></Tooltip>)
  if (status === 'DISPATCHED') return (<Tooltip title={status} placement="top"><CheckCircleIcon style={{ color: grey[500] }} /></Tooltip>)    
  if (status && status.endsWith('ING')) return (<Tooltip title={status} placement="top"><CircularProgress disableShrink size={20} /></Tooltip>)  
  if (status === 'ERROR') return (<Tooltip title={status} placement="top"><ErrorOutlineIcon style={{ color: grey[500] }} /></Tooltip>)
  return status;
}